export default {
    namespaced: true,
    state: {
        pagina: 'HARTFORD CONSULTAS',
        url:    'https://iberopa.com/_abk/exec.php',
        url_img:'https://iberopa.com/_abk/lib/imagendb.php',
        url_tmp:'https://iberopa.com/_abk/tmp/',

        abk_url: {
            user:   'abakan',
            salida: 'json',
            clase:  'adm/hfsl/hfsl',
            fnt:    '',
            args:   [],
        },

    },
    mutations: {
    },
    actions: {
    },
    getters: {
    }
}